import { useLDClient } from "launchdarkly-react-client-sdk";

export const IS_TESTING_ENABLED = false;
const NEW_FEATURE_FLAG_NAME = "portal-ui.new-item-indicator";

export type TNewFeatureTags = Record<string, boolean>;

export const QA_TEST_TAGS: TNewFeatureTags = {
	inventorySchedulePrice: true,
	inventoryFlashSale: true,
	inventoryAutopricer: true,
	inventoryMarkTicketReviewed: true,
	inventoryMarkTicketsInHand: true,
	inventoryInternalInvoice: true,
	inventoryCreateInvoice: true,
	inventoryShareUnshare: true,
	inventorySplitListing: true,
	inventoryDuplicateListing: true,
	inventoryEDelivery: true,
	inventoryRelistListing: true,
	inventoryInternalNotes: true,
	inventoryExternalNotes: true,
	inventoryListingInfo: true,
	inventoryAddTag: true,
	inventoryPurchaseInformation: true,
	inventoryTickets: true,
	inventoryAttachPdfs: true,
	inventoryReleaseListing: true,
	inventoryViewHistory: true,
	inventoryContactUser: true,
	inventoryHelpAndSupport: true,
};

export const useNewFeatureTags = (): TNewFeatureTags => {
	const ldClient = useLDClient();
	const value = ldClient?.variation(NEW_FEATURE_FLAG_NAME, {});

	if (IS_TESTING_ENABLED) return QA_TEST_TAGS;

	if (!value || typeof value !== "object" || Array.isArray(value)) return {};

	return Object.entries(value).reduce<TNewFeatureTags>((acc, [tagId, isEnabled]) => {
		if (typeof isEnabled === "boolean") acc[tagId] = isEnabled;
		return acc;
	}, {});
};

export const useIsNewFeatureTagActive = (tagId: string): boolean => {
	const tags = useNewFeatureTags();

	if (!tagId) return false;

	return tags[tagId] === true;
};
